import {
    useDispatch
} from "react-redux";

import {
    bindActionCreators
} from "redux";

import ActionsCreators from "@Actions-Creators";


export const UseActions = () => {

    const dispatcher = useDispatch();

    return bindActionCreators(ActionsCreators, dispatcher);

};


export default UseActions;
